import SurveyWizard from './SurveyWizard';

export default SurveyWizard;
